export async function resolveNFD(address: string): Promise<string | null> {
    try {
        const res = await fetch(
            `https://api.nf.domains/nfd/lookup?address=${encodeURIComponent(address)}&limit=1&view=thumbnail`,
            { headers: { Accept: 'application/json' } },
        );
        if (!res.ok) return null;
        const data = await res.json() as Record<string, { name?: string }>;
        return data[address]?.name ?? null;
    } catch {
        return null;
    }
}
